<div class="modal-backdrop" *ngIf="isOpen" [attr.data-theme]="theme" [@backdropAnim] (click)="onBackdropClick()">
  <div class="modal-box {{height ? height : ''}}" [ngClass]="'modal-' + size" [@modalAnim] (click)="$event.stopPropagation()">

    <div class="modal-header" *ngIf="title || showCloseButton || hasCustomHeader">
      <ng-content select="[modal-header]"></ng-content>

      <h3 class="modal-title" *ngIf="title && !hasCustomHeader">{{ title }}</h3>

      <button type="button" class="modal-close-btn" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <ng-content></ng-content>
    </div>

  </div>
</div>